import { render } from "./PlansOptions.vue?vue&type=template&id=6cf21886&scoped=true"
import script from "./PlansOptions.vue?vue&type=script&lang=js"
export * from "./PlansOptions.vue?vue&type=script&lang=js"

import "./PlansOptions.vue?vue&type=style&index=0&id=6cf21886&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf21886"]])

export default __exports__